      <!-- TODO: 点击事件 -->
<template>
  <div id="detail">
    <bread :content="breadContent"></bread>
    <p class="Page-title">{{ breadContent[2] ? breadContent[2].text : ''}}</p>
    <el-divider></el-divider>
    <div class="container">
      <blockTime :year="yy" :month="mm" :day="dd"></blockTime>
      <Article :width="'80%'" :margin="'20px 10% 0 75px'" :title="title" :authors="authors" :html="html"></Article>
    </div>
  </div>
</template>

<script>
import bread from '@/components/bread';
import Article from '@/components/article'
import blockTime from '@/components/blockTime'
import Api from '@/network.js'

export default {
  name: 'detail',
  data() {
    return {
      breadContent: [],
      id: this.$route.query.id,
      title: '',
      authors: '',
      yy: '',
      mm: '',
      dd: '',
      html: ''
    }
  },
  components: {
    bread,
    Article,
    blockTime
  },
  methods: {
    setData(obj) {
      // 将obj与this.data合并
      Object.assign(this.$data, obj)
    }
  },
  async beforeRouteEnter (to, from, next) {
    const type = to.query.type;
    const id = to.query.id
    let data = {}, res
    if (type === 'paper') {
      res = await Api.studyResult.getPaperDetail(id);
      data.breadContent = [
        {text:'首页', routerName:'index'},
        {text:'研究成果', routerName:'studyResult'},
        {text:'学术论文', routerName:'academicPaper'}
      ]
    }
    else if (type === 'report') {
      res = await Api.studyResult.getResultDetail(id);
      data.breadContent = [
        {text:'首页', routerName:'index'},
        {text:'研究成果', routerName:'studyResult'},
        {text:'研究报告', routerName:'researchReport'}
      ]
    }
    else if (type === 'apply') {
      res = await Api.studyResult.getApplyDetail(id);
      data.breadContent = [
        {text:'首页', routerName:'index'},
        {text:'研究成果', routerName:'studyResult'},
        {text:'成果应用', routerName:'achievementApply'}
      ]
    }
    data.title = res.Title
    data.authors = res.Author
    data.html = res.Content
    const date = res.Date || res.AdminSetTime // apply类型返回后者
    if (date) {
      data.yy = date.split('-')[0]
      data.mm = date.split('-')[1]
      data.dd = date.split('-')[2]
    }
    next(vm => {
      vm.setData(data)
      // 指定高亮菜单栏文字
      vm.$store.commit('setHighlightText', vm.breadContent[2].text)
    })
  },
  // 离开详情页时清除侧边栏高亮项，防止冲突
  destroyed() {
    this.$store.commit('setHighlightText', '')
  }
}
</script>

<style lang="scss" scoped>
  #detail {
    width: calc(100% - 250px);
    margin-left: 50px;
    margin-top: 40px;
  }
  .container {
    position: relative;
    padding-top: 10px;
    .blockTime {
      position: absolute;
      left: 0;
      top: -10px;
    }
  }
</style>
